var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.settings.isLoading,
              expression: "settings.isLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            stripe: "",
            data: _vm.data,
            "header-cell-style": { background: "#f5f7fa" }
          },
          on: {
            "selection-change": function(e) {
              return _vm.handleClick("select", e)
            }
          }
        },
        [
          _vm.settings.isSelection
            ? _c("el-table-column", {
                attrs: {
                  width: "55",
                  type: "selection",
                  fixed: "",
                  align: "center"
                }
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "序号",
              width: "55",
              index: _vm.indexMethod,
              fixed: "",
              align: "center"
            }
          }),
          _vm._l(_vm.header, function(item) {
            return [
              !item.slotName
                ? _c("el-table-column", {
                    key: item.prop,
                    attrs: {
                      type: item.type,
                      prop: item.prop,
                      label: item.label,
                      width: item.width,
                      fixed: item.fixed,
                      align: "center"
                    }
                  })
                : _c("el-table-column", {
                    key: item.prop,
                    attrs: {
                      label: item.label,
                      width: item.width,
                      fixed: item.fixed,
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._t(item.slotName, null, {
                                scope: { row: scope.row, index: scope.$index }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
            ]
          })
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { "text-align": "right", padding: "6px 0" },
        attrs: {
          background: "",
          "current-page": _vm.currentPage,
          "page-sizes": [5, 10, 20],
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.settings.total
        },
        on: {
          "size-change": function(e) {
            return _vm.handleClick("pageSizeChange", e)
          },
          "current-change": function(e) {
            return _vm.handleClick("currentPageChange", e)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }